package dev.jfronny.zerointerest.util

data class Timed<T>(val ts: Long, val value: T)
